import { render, staticRenderFns } from "./Benutzerverwaltung.vue?vue&type=template&id=99e3aa52&scoped=true&"
import script from "./Benutzerverwaltung.vue?vue&type=script&lang=js&"
export * from "./Benutzerverwaltung.vue?vue&type=script&lang=js&"
import style0 from "./Benutzerverwaltung.vue?vue&type=style&index=0&id=99e3aa52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e3aa52",
  null
  
)

export default component.exports